import React from 'react';

export interface ReportContextState {
  childName: string;
  setChildName: (v: string) => void;
  reportDate: string;
  setReportDate: (v: string) => void;
  showHeader: boolean;
  setShowHeader: (v: boolean) => void;
  pdfPassword: string;
  setPdfPassword: (v: string) => void;
  /**
   * Generation-panel entries for the template's manual-editable header
   * fields, by field key. A key is only present once its input has been
   * touched: absent = the template default applies; present-but-empty = the
   * user cleared it, which omits the row (see resolveHeaderField).
   */
  fieldValues: Record<string, string>;
  setFieldValue: (key: string, value: string) => void;
}

export const ReportContext = React.createContext<ReportContextState>({
  childName: '',
  setChildName: () => {},
  reportDate: '',
  setReportDate: () => {},
  showHeader: false,
  setShowHeader: () => {},
  pdfPassword: '',
  setPdfPassword: () => {},
  fieldValues: {},
  setFieldValue: () => {},
});

export const ReportProvider = ReportContext.Provider;
